import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const slides = [
  {
    headline: 'Financial Excellence &',
    subheadline: '30+ Years of Trust',
    body: 'ASRM & Co. — Your premier Chartered Accountants firm providing comprehensive audit, tax, and advisory services across India.',
    cta: { label: 'Our Services', to: '/services' },
    image: '/images/hero/slide1.jpg',
  },
  {
    headline: 'Expert Audit &',
    subheadline: 'Assurance Services',
    body: 'Comprehensive review ensuring your accounts comply with Generally Accepted Accounting Policies and applicable Accounting Standards/IFRS.',
    cta: { label: 'Learn More', to: '/services/audit' },
    image: '/images/hero/slide2.jpg',
  },
  {
    headline: 'GST, Tax Planning &',
    subheadline: 'Corporate Advisory',
    body: 'Filing of GST Returns, Income Tax planning, Corporate Law matters, and Business Consultancy — all under one roof.',
    cta: { label: 'Contact Us', to: '/contact' },
    image: '/images/hero/slide3.jpg',
  },
];

export default function Hero() {
  return (
    <section className="hero-section">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5500, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        className="hero-swiper"
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            <div className="hero-slide">
              {/* Background pattern */}
              <div className="hero-pattern" />
              {/* Animated accent circles */}
              <div className="hero-circle1" />
              <div className="hero-circle2" />
 
              <div className="container hero-slide-content">
                <div className="hero-text-block">
                  <h1 className="hero-headline">
                    {slide.headline}<br />
                    <span className="hero-accent-text">{slide.subheadline}</span>
                  </h1>
                  <p className="hero-body">{slide.body}</p>
                  <div className="hero-actions">
                    <Link to={slide.cta.to} className="btn-primary">
                      {slide.cta.label} <FiArrowRight />
                    </Link>
                  </div>
                  <div className="hero-stats">
                    <div className="hero-stat">
                      <span className="hero-stat-num">30+</span>
                      <span className="hero-stat-label">Years Experience</span>
                    </div>
                    <div className="hero-stat-divider" />
                    <div className="hero-stat">
                      <span className="hero-stat-num">500+</span>
                      <span className="hero-stat-label">Clients Served</span>
                    </div>
                    <div className="hero-stat-divider" />
                    <div className="hero-stat">
                      <span className="hero-stat-num">11+</span>
                      <span className="hero-stat-label">Service Areas</span>
                    </div>
                  </div>
                </div>
 
                {/* Right side: Image block + decor card overlay */}
                <div className="hero-image-block">
                  <div className="hero-image-wrapper">
                    <img src={slide.image} alt={slide.headline} className="hero-image-img" />
                  </div>
                  
                  {/* Decorative card overlay */}
                    <div className="hero-decor-card">
                      <div className="hero-decor-header">
                        <img src="/images/logo/logo-m.png" alt="ASRM Logo" className="hero-decor-logo-img" />
                        <span>Chartered Accountants</span>
                      </div>
                    <div className="hero-decor-services">
                      {['Audit', 'Tax', 'GST', 'Corporate Law', 'Accounting', 'Payroll'].map((s) => (
                        <span key={s} className="hero-decor-tag">{s}</span>
                      ))}
                    </div>
                    <div className="hero-decor-footer">
                      <span>📍 Shri Vijaya Puram(Port Blair), Kolkata & Asansol</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
